/**
 * LayoutToggle — Schalter für die Breite der Beitragsansicht.
 * Drei Stellungen, siehe useLayoutMode.
 */

import type { LayoutMode } from '../hooks/useLayoutMode'

const OPTIONS: Array<{ mode: LayoutMode; icon: string; label: string; title: string }> = [
  { mode: 'wide', icon: 'fa-arrows-alt-h', label: 'Volle Breite', title: 'Volle Breite: der Inhalt nutzt die ganze Seite' },
  { mode: 'centered', icon: 'fa-align-center', label: 'Zentriert', title: 'Zentriert: eine gut lesbare Spalte in der Mitte' },
  { mode: 'paper', icon: 'fa-file', label: 'Blatt', title: 'Blatt: Hochformat wie Papier, durchlaufend ohne Seitenwechsel' },
]

export function LayoutToggle({ mode, onChange }: { mode: LayoutMode; onChange: (mode: LayoutMode) => void }) {
  return (
    <div className="view-mode-toggle layout-toggle" role="group" aria-label="Breite der Ansicht">
      {OPTIONS.map((o) => (
        <button
          key={o.mode}
          type="button"
          className={`view-mode-btn ${mode === o.mode ? 'active' : ''}`}
          title={o.title}
          aria-label={o.label}
          aria-pressed={mode === o.mode}
          data-layout-option={o.mode}
          onClick={() => onChange(o.mode)}
        >
          <i className={`fas ${o.icon}`} />
        </button>
      ))}
    </div>
  )
}
